<!--  -->
<template>
    <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="r_literature_type" label="Type" width="120">
            <template slot-scope="scope">
                <div @click="openDetails(scope.row.r_id)">
                    {{ scope.row.r_literature_type }}
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="r_title" label="Title" min-width="30%">
            <template slot-scope="scope">
                <div @click="openDetails(scope.row.r_id)" v-html="scope.row.r_title"></div>
            </template>
        </el-table-column>
        <el-table-column prop="" label="Author" width="120">
            <template slot-scope="scope">
                <div @click="openDetails(scope.row.r_id)">
                    {{ innerHTML(scope.row.r_author) }},{{
                        innerHTML(scope.row.r_joint_author)
                    }}
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="r_year" label="Year" width="120">
            <template slot-scope="scope">
                <div @click="openDetails(scope.row.r_id)">
                    {{ innerHTML(scope.row.r_year) }}
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="r_doi" label="Doi" min-width="30%">
            <template slot-scope="scope">
                <div @click="openDetails(scope.row.r_id)">
                    {{ innerHTML(scope.row.r_doi) }}
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="tags" label="Tags" min-width="30%">
            <template slot-scope="scope">
                <div @click="openDetails(scope.row.r_id)">{{ scope.row.tags }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="address" label="Operation" width="120">
            <template slot-scope="scope">
                <el-popover placement="right" width="400" trigger="click">
                    <div class="cite-content">
                        <div class="cite-title cite-item">
                            <h1>Cite</h1>
                        </div>
                        <div class="cite-tip cite-item">
                            Copy and paste an established citation format, or import it into
                            document management software using one of the links.
                        </div>
                        <div class="gb-t child cite-item">
                            <label>GB/T 7714</label>
                            <span class="gbt">
                                {{ innerHTML(scope.row.r_author) }},{{
                                    innerHTML(scope.row.r_joint_author)
                                }}.{{ innerHTML(scope.row.r_title) }}.{{
    innerHTML(scope.row.r_journal)
}},{{ innerHTML(scope.row.r_year) }},{{
    innerHTML(scope.row.r_volume)
}}({{ innerHTML(scope.row.r_issue) }}):{{
    innerHTML(scope.row.r_pages)
}}.
                            </span>
                        </div>
                        <div class="cite-mla child cite-item">
                            <label>MLA</label>
                            <span class="mla">
                                {{ innerHTML(scope.row.r_author) }},{{
                                    innerHTML(scope.row.r_joint_author)
                                }}.{{ innerHTML(scope.row.r_title) }}.{{
    innerHTML(scope.row.r_journal)
}},{{ innerHTML(scope.row.r_volume) }}.{{
    innerHTML(scope.row.r_issue)
}}({{ innerHTML(scope.row.r_year) }}):{{
    innerHTML(scope.row.r_pages)
}}.
                            </span>
                        </div>
                        <div class="cite-apa cite-item">
                            <label>APA</label>
                            <span class="apa">
                                {{ innerHTML(scope.row.r_author) }},{{
                                    innerHTML(scope.row.r_joint_author)
                                }}.({{ innerHTML(scope.row.r_year) }}){{
    innerHTML(scope.row.r_title)
}}.{{ innerHTML(scope.row.r_journal) }},{{
    innerHTML(scope.row.r_volume)
}}({{ innerHTML(scope.row.r_issue) }}),{{ scope.row.r_pages }}.
                            </span>
                        </div>
                        <div class="cite-links cite-item">
                            <label>Inbound links:</label>
                            <span>
                                <a target="_blank"
                                    :href="deepBoneDomin + 'index/literature/cite_download?r_id=' + scope.row.r_id + '&type=BibTeX'"
                                    :data-id="scope.row.r_id" download>BibTeX</a>
                                <a target="_blank" :href="deepBoneDomin +
                                    '/api/literature-paperclip/' +
                                    scope.row.r_id +
                                    ''
                                    " :data-id="scope.row.r_id" download>EndNote</a>
                                <a target="_blank" :href="deepBoneDomin +
                                    'index/literature/cite_download?r_id=' +
                                    scope.row.r_id +
                                    '&type=RefMan'
                                    " :data-id="scope.row.r_id" download>RefMan</a>
                                <a target="_blank" :href="deepBoneDomin +
                                    'index/literature/cite_download?r_id=' +
                                    scope.row.r_id +
                                    '&type=NoteFirst'
                                    " :data-id="scope.row.r_id" download>NoteFirst</a>
                                <a target="_blank" :href="deepBoneDomin +
                                    'index/literature/cite_download?r_id=' +
                                    scope.row.r_id +
                                    '&type=NoteExpress'
                                    " :data-id="scope.row.r_id" download>NoteExpress</a>
                            </span>
                        </div>
                    </div>
                    <el-button slot="reference" type="text" class="cite-btn" @click="showCite">Cite</el-button>
                </el-popover>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { deepBoneDomin, ossImage } from "@/common.js";
import { mixins } from "@/mixins/index.js";
import { utlogMap } from '@/api/index.js';
import { functionId } from '@/utils/browser.js';
export default {
    mixins: [mixins],
    props: ["tableData"],
    data() {
        return {
            deepBoneDomin: deepBoneDomin,
            ossImage: ossImage,
            routerName: '',
            tibetName: "TibetPlateau",
            // tableData:[]
        };
    },
    //生命周期 - 创建完成（访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        // console.log(this.tableData);
        this.routerName = this.$route.name;
    },
    methods: {
        openDetails(r_id) {
            let functionId = {
                functionId:(this.routerName == this.tibetName) ? 'Deepbone_tibet_literatureSearchResultOpen' : 'Deepbone_explore_literatureSearchResultOpen',
            }
            let logMap = {
                eventType: "clk",
                url: window.location.href,
                functionId: functionId.functionId
            };
            utlogMap(logMap).then((res) => {
                // console.log(res);
            });
            this.$router.push({
                name: "literature",
                params: {
                    r_id,
                    ...functionId
                },
            });
        },
        showCite() {
            let logMap = {
                eventType: "clk",
                url: window.location.href,
                functionId: (this.routerName == this.tibetName) ? 'Deepbone_tibet_literatureReferenceView' : 'Deepbone_explore_literatureReferenceView',
            };
            utlogMap(logMap).then((res) => {
                // console.log(res);
            });
        },
    },
};
</script>
<style>
.cite-btn:focus,
.cite-btn {
    color: #72c2c9;
    text-align: center;
}

.literature .el-table td.el-table__cell:last-child div {
    text-align: center;
}

.el-popover {
    background: #ffffff;
    border-radius: 2px;
    padding: 20px;
    border: none;
}

.cite-content .cite-item {
    padding: 10px 0;
}

.cite-content .cite-item label {
    display: inline-block;
    vertical-align: top;
    width: 118px;
    font-size: 20px;
    line-height: 24px;
    color: #484d63;
    font-weight: 600;
}

.cite-content .cite-item:last-child label {
    font-size: 16px;
    color: #c4c4c4;
}

.cite-content .cite-item>span {
    display: inline-block;
    width: calc(100% - 118px);
    /* 整个单词换行 */
    word-break: break-word;
    text-align: left;
}

.cite-content .cite-item>span a {
    color: #72c2c9;
    padding: 0 14px;
}

.cite-content .child {
    border-bottom: 2px solid #efefef;
}

.cite-title {
    font-size: 24px;
    line-height: 28px;
}

.cite-title h1 {
    font-weight: 600;
}

.cite-tip {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #c4c4c4;
    word-break: break-word;
    text-align: left;
}

.cite-gb-t {}

.cite-mla {}

.cite-apa {}

.cite-links {}
</style>
